import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import "./Topbar.css"

const useStyles = makeStyles(() => ({
    root: {
      "& .MuiSvgIcon-root": {
            fontSize:18,
            marginBottom: 1,
            marginLeft: "8px",
            height: 17,
            opacity: 0.50,
            cursor: "pointer"
        }
    },
}));

const Tag = ({
    tag,
    handleTagRemoval
}) => {
    const classes = useStyles();
    function handleClick(tag){
        handleTagRemoval(tag[0], tag[1])
    }   
    return ( 
        <div className="react-TagContainer">
            <div className="react-TagOption">
                {tag[1]}
                <div className={classes.root}>
                    <Close
                        onClick={
                            () => {
                                handleClick(tag)
                            }
                        }
                    />
                </div>
            </div>
        </div>
     );
}
 
export default Tag;